import withLabel from 'admin-components/components/withLabel/withLabel';
import CurrencySelect from './CurrencySelect';

export default withLabel(CurrencySelect);
